/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react'
import { getMessage } from 'lib/translator'
import ListingPage from 'containers/ListingPage'
import ScanRewardTableProperties from './ScanRewardsTableProperties'
import emptyIcon from 'icons/no-orders.svg'
import ScanRewardFilter from './ScanRewardFilter'

const ScanRewardsTable = ({ menu, location }) => {
  const hasQueryParams = location?.search && location.search.length > 1

  return (
    <ListingPage
      testid="offer-scan-reward-listing"
      menu={menu}
      className="offer-scan-reward-page"
      title={getMessage('offer.scanRewards.listing.heading')}
      api={{
        url: '/scan-campaign-service/campaigns/rewards',
        transform: (response) => response?.data?.customerReward || [],
      }}
      tableDynamic
      noSearch="true"
      primaryKey="id"
      tableProperties={ScanRewardTableProperties()}
      emptyState={{
        icon: emptyIcon,
        message: getMessage('offer.scanRewards.listing.noCampaign'),
      }}
      filters={{
        component: ScanRewardFilter,
        forceShow: true,
        transformSubmit: (response) => {
          return JSON.parse(JSON.stringify(response))
        },
      }}
      nextPrevButtonsEnabled
      dontSavePagination
      dontFetchOnMount={!hasQueryParams}
    />
  )
}

export default ScanRewardsTable
